import React, { Component } from "react";
import { Icon, Step } from "semantic-ui-react";
import { Translate } from "react-localize-redux";


export default class StepList extends Component {

    render() {

        const active = this.props.active;

        return <Step.Group attached='top'>
            <Step completed={active > 1} active={active === 1}
                  disabled={active !== 1}>
                <Icon name='search'/>
                <Step.Content>
                    <Step.Title><Translate id="tools.general.steps.1.title"/></Step.Title>
                    <Step.Description><Translate
                        id="tools.general.steps.1.description"/></Step.Description>
                </Step.Content>
            </Step>

            <Step completed={active > 2} active={active === 2}
                  disabled={active !== 2}>
                <Icon name='add'/>
                <Step.Content>
                    <Step.Title><Translate id="tools.general.steps.2.title"/></Step.Title>
                    <Step.Description><Translate
                        id="tools.general.steps.2.description"/></Step.Description>
                </Step.Content>
            </Step>

            <Step completed={active > 3} active={active === 3}
                  disabled={active !== 3}>
                <Icon name='options'/>
                <Step.Content>
                    <Step.Title><Translate id="tools.general.steps.3.title"/></Step.Title>
                    <Step.Description><Translate
                        id="tools.general.steps.3.description"/></Step.Description>
                </Step.Content>
            </Step>

            <Step completed={active > 4} active={active === 4}
                  disabled={active !== 4}>
                <Icon name='dollar'/>
                <Step.Content>
                    <Step.Title><Translate id="tools.general.steps.4.title"/></Step.Title>
                    <Step.Description><Translate
                        id="tools.general.steps.4.description"/></Step.Description>
                </Step.Content>
            </Step>

            <Step completed={active > 5} active={active === 5}
                  disabled={active !== 5}>
                <Icon name='info'/>
                <Step.Content>
                    <Step.Title><Translate id="tools.general.steps.5.title"/></Step.Title>
                    <Step.Description><Translate
                        id="tools.general.steps.5.description"/></Step.Description>
                </Step.Content>
            </Step>
        </Step.Group>;
    }

}



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/StepList/index.js